import React, {useEffect, useState} from "react";
import {Modal, ScrollView, View} from "react-native";
import MainStyle from "../../MainStyle";
import Div from "../lib/Div";
import P from "../lib/P";
import FontAwesome5 from "@expo/vector-icons/FontAwesome5";
import OnlinePayment from "../components/OnlinePayment";

type Props = { visible: boolean, onRequestClose: () => void, amountCents: number };

const CardDetailsModal = (props: Props) => {
  const {visible, amountCents} = props;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const requestClose = () => {
    if (!isSubmitting) props.onRequestClose();
  };

  useEffect(() => {
    if (!visible) setIsSubmitting(false);
  }, [visible]);

  return (
    <Modal animationType="fade" transparent visible={visible} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={requestClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <Div minH="100%" alignItems="center" justifyContent="center">
            <Div bg="#131314" w={343} rounded={16} overflow="hidden">
              <Div position="relative" bg="#252526" justifyContent="center">
                <P fontFamily="DavisSans-Medium" ta="center" lh={48}>Enter Card Details</P>
                <FontAwesome5
                  name="times" size={28} color="white" style={[MainStyle.absolute, MainStyle.r_10]}
                  onPress={requestClose}
                />
              </Div>

              <Div mx={16}>
                <OnlinePayment
                  amountCents={amountCents} active={visible} goBack={props.onRequestClose}
                  onSubmittingChange={setIsSubmitting}
                />
              </Div>
            </Div>
          </Div>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default CardDetailsModal;
